import React from 'react';
import PropTypes from "prop-types";

function BlockName(props) {
  if (_.isUndefined(props.page) || !props.page.hasOwnProperty('blockName')) {
    return null;
  }

  return (
    <div className="block-name">
      {props.page.blockName}
    </div>
  )
}

BlockName.propTypes = {
  page: PropTypes.shape({
    blockName: PropTypes.string,
  }),
};

export default BlockName;